import React from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";

const DarkBackdrop = styled(Backdrop)(({ theme }) => ({
  zIndex: 100001,
  backgroundColor: "rgba(0, 0, 0, 0.7)", 
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "100vh",
}));

const LoaderComponent = ({ message }) => (
  <DarkBackdrop open={true}>
    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 2, color: "#fff" }}>
      <CircularProgress color="inherit" />
      {message && <Typography color="inherit" role="status">{message}</Typography>}
    </Box>
  </DarkBackdrop>
);

export default LoaderComponent;
